class Slideshow {
    constructor(el) {
        this.el = el;
    }

    build() {
        let imgs = this.el.querySelectorAll('img');
        this.el.innerHTML += `<div class="dots"> </div>`; 
        let dots = this.el.querySelector('.dots');
        Object.keys(imgs).forEach(i => {
            dots.innerHTML += `<div class="dot" data-id="${i}" onclick="move(${i})"> </div>`;
        });
        move(0, 0);
    }

}

function move(a) {
    let slideshow = document.querySelector('.slideshow');
    let elements = {
        curDot: slideshow.querySelector(`[data-id="${a}"`),
        dots: slideshow.querySelectorAll('[data-id]'),
        imgs: slideshow.querySelectorAll('.slide__wrapper'),
        arrLeft: slideshow.querySelector('.arrow.left'),
        arrRight: slideshow.querySelector('.arrow.right')
    }
    Object.keys(elements.imgs).forEach(i => {
        elements.imgs[i].style.right = a * 100 + 'vw';
        elements.dots[i].classList.remove('active')
    });
    elements.curDot.classList.add('active');
    let currentPos = parseInt(elements.curDot.dataset.id);
    let lastPos = parseInt(elements.imgs.length);
    elements.arrLeft.dataset.index = currentPos - 1;
    elements.arrRight.dataset.index = currentPos + 1;
    if(currentPos == 0) {
        elements.arrLeft.dataset.index = lastPos - 1;
    }
    else if(currentPos == lastPos - 1) {
        elements.arrRight.dataset.index = 0;
    }
    
}


let loadSlideshows = () => {
    let slideshow = document.querySelector('.slideshow');
    let newSlideshow = new Slideshow(slideshow);
    newSlideshow.build();
}

document.addEventListener('load', loadSlideshows());